/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MessageStatus/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import Delivered from './Delivered/index'
import Failed from './Failed/index'
import No from './No/index'
import React from 'react'
import Sending from './Sending/index'
import Undelivered from './Undelivered/index'



/** @type {import('Simple/types.js').View} */
export default function MessageStatus({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/EventsTimeline/Content/Event/Types/Sms/Content/Outbound/Info/MessageStatus"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let smsTwilioMessageStatusValueData = fromData.useDataFormat({ viewPath,
context: 'sms',
path: 'twilio_message_status',
format: fromFormat.smsMessageStatus,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: smsTwilioMessageStatusValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Sending'}>
<Sending
  viewPath={`${viewPath}/Sending`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Delivered'}>
<Delivered
  viewPath={`${viewPath}/Delivered`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Undelivered'}>
<Undelivered
  viewPath={`${viewPath}/Undelivered`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Failed'}>
<Failed
  viewPath={`${viewPath}/Failed`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}